// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__FariP","sendOtp":"AuthorizeToLogin_sendOtp__1IhH9"};